import { andJoin, createLabeledMessages, slashJoin } from '../../../messageUtils';
const searchForm = {
    identification: slashJoin('person:birthNumber_short', 'person:ico'),
    searchTooltip: 'Rodné číslo zadajte bez lomítka. V prípade cudzinca vyplňte vo formáte RRMMDD9999',
    searchButton: 'vyhľadať poistníka'
};
const searchResult = {
    resultTitle: 'Výsledky vyhľadávania klienta',
    createButton: 'založiť nového klienta',
    clientName: andJoin('person:firstName_label', 'person:surname'),
    combinedName: slashJoin('clientSearch:clientName', 'common:name_label'),
    resultCount_one: 'Bol nájdený {{count}} klient.',
    resultCount_few: 'Boli nájdení {{count}} klienti.',
    resultCount_other: 'Bolo nájdené {{count}} klientov.'
};
const messages = Object.assign({}, searchForm, searchResult);
export default Object.assign({}, messages, createLabeledMessages(messages));
